import { render, staticRenderFns } from "./SettingsEventsView.vue?vue&type=template&id=5c40ca82&scoped=true&lang=pug"
import script from "./SettingsEventsView.vue?vue&type=script&lang=ts"
export * from "./SettingsEventsView.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEventsView.vue?vue&type=style&index=0&id=5c40ca82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40ca82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VContainer,VProgressLinear,VRow})
